function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Rect, {
  fill: "#DDD",
  width: "100%",
  height: "100%"
});

var _ref2 = /*#__PURE__*/React.createElement(Path, {
  d: "M186.787 145.55c1.783 21.661 6.183 49.858 6.183 49.858s-8.717 4.727-8.717 23.747c3.036 47.745 19.022 27.14 22.308 48.08 7.91 50.442 25.985 41.46 25.985 68.99 0 45.853-18.939 67.293-78.065 92.709C95.159 454.46 34 486.578 34 542.193V570h501.307v-27.807c0-55.615-61.187-87.732-120.536-113.232-59.127-25.415-78.01-46.827-78.01-92.71 0-27.528 18.02-18.547 25.957-68.989 3.315-20.939 19.273-.334 22.364-48.079 0-19.02-8.745-23.747-8.745-23.747s4.4-28.197 6.155-49.859c1.46-18.32-6.642-53.4-37.61-74.1-7.435-4.97-8.63-4.975-18.887-7.856-1.943-5.817-16.384-16.036-27.438-16.56-21.384-1.013-55.36 10.666-77.263 26.468-28.296 21.022-35.9 54.307-34.507 72.02z",
  fill: "#F5F5F5"
});

function SvgUserPlaceholder(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 570 570",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgUserPlaceholder;